import Document, { Html, Head, Main, NextScript } from 'next/document'

import environment from 'environment'

// TODO - removing to see what breaks
// import StyledComponentsManager from 'components/misc/StyledComponentsManager'

import { themes } from 'components/misc/GlobalToolbar/DarkModeToggle'

import { THEME } from 'types/active'
import { ROLES } from 'types/user'

//@ts-ignore
export default class MyDocument extends Document {
  static async getInitialProps(ctx: any) {
    handleSetupCanary(ctx)

    const bodyClass = `${ctx.req.cookies.theme}` === THEME.DARK ? themes.dark.class : themes.light.class

    const tier = ctx.req.cookies.tbTier || 0
    const roles = ctx.req.cookies.tbR || []
    const expiresAt = new Date(ctx.req.cookies.tbFreeTrialExpiresAt || '1999-01-01')
    const now = new Date()

    const adFree =
      roles.includes(ROLES.AD_FREE) ||
      Number(tier) ||
      (environment.nodeEnv === 'development' && !environment.enableAdsOnLocalhost) ||
      now <= expiresAt

    try {
      const initialProps = await Document.getInitialProps(ctx)

      return {
        ...initialProps,
        bodyClass,
        adFree,
        styles: <>{initialProps.styles}</>,
      }
    } catch (err) {
      console.error(err)

      return {
        bodyClass,
        adFree,
      }
    }
  }

  render() {
    return (
      <Html lang="en">
        <Head>
          <meta property="og:site_name" content="Archidekt" />

          <style>
            @import
            url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
            @import url('//cdn.jsdelivr.net/npm/mana-font@latest/css/mana.css'); @import
            url('https://cdnjs.cloudflare.com/ajax/libs/quill/1.2.6/quill.snow.css'); @import
            url('https://cdn.jsdelivr.net/npm/keyrune@latest/css/keyrune.css');
          </style>

          {/* <!-- Smooth scrolling ios - https://github.com/iamdustan/smoothscroll --> */}
          <script defer src="https://unpkg.com/smoothscroll-polyfill@0.4.4/dist/smoothscroll.min.js"></script>

          {/* Ad shit */}
          {/* @ts-ignore */}
          {!this.props.adFree && (
            <script async type="module" src="https://ads.archidekt.com/loader.js" crossOrigin="use-credentials" />
          )}

          {/* Required for the rich text toolbar - could be removed if we made a custom one ourselves for desktop */}
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.2.6/quill.snow.css"
            crossOrigin="anonymous"
          />
        </Head>

        {/* @ts-ignore */}
        <body className={`${this.props.bodyClass} ${!this.props.adFree ? 'ads-enabled' : ''}`}>
          <Main />
          <NextScript />
        </body>
      </Html>
    )
  }
}

export const canaryCookieKey = 'canaryEnabled'
export const canaryVersionKey = 'canaryVersion'
export const canaryRandomValueKey = 'canaryRoll'

const currentCanaryVersion = '3' // Change this if we're running a new canary campagin - makes everything reroll from scratch when changed
const rolloutPercentage = 0.6 // Change this to set the % rollout per canary version

const handleSetupCanary = (ctx: any) => {
  const manualCanary = ctx.query.canary // Allows the user to manually override any canary property via query params
  const canaryVersion = ctx.req.cookies[canaryVersionKey] || '0'
  const canaryWasEnabled = (ctx.req.cookies[canaryCookieKey] || '0') === '1'

  const onCurrentVersion = canaryVersion === currentCanaryVersion
  const expiresAt = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365) // One year

  // If the user manually switches canary versions, let them. Overrides all other factors
  if (manualCanary !== undefined && (manualCanary === '0' || manualCanary === '1')) {
    ctx.res.appendHeader('Set-Cookie', `${canaryCookieKey}=${manualCanary}; Path=/; Expires=${expiresAt}`)

    return manualCanary === '1'
  }

  // If they were ever on canary leave them on canaray. Kicking people back and forth is not a good experience.
  // If you wish to clear users off of the existing canary build, update the canaryVersionKey and start a new canary campaign from scratch
  if (onCurrentVersion && canaryWasEnabled) return true

  // If we're on the current version, use the random value stored in the cookie. If the version changes, generate a new one
  const canaryRoll = Number(onCurrentVersion ? ctx.req.cookies[canaryRandomValueKey] || Math.random() : Math.random())
  const isCanaryEnabled = canaryRoll < rolloutPercentage ? '1' : '0'

  ctx.res.appendHeader('Set-Cookie', `${canaryCookieKey}=${isCanaryEnabled}; Path=/; Expires=${expiresAt}`)
  ctx.res.appendHeader('Set-Cookie', `${canaryVersionKey}=${currentCanaryVersion}; Path=/; Expires=${expiresAt}`)
  ctx.res.appendHeader('Set-Cookie', `${canaryRandomValueKey}=${canaryRoll}; Path=/; Expires=${expiresAt}`)

  return isCanaryEnabled === '1'
}
